import { gql } from "@apollo/client";

import {
  PRINT_USER_PROFILE_FIELDS,
  USER_REPORT_PRINT_EXTENSION_FIELDS,
  USER_RESULT_PRINT_CORE_FIELDS
} from "@/components/reports/print/fragments";

import { REPORT_FIELDS, USER_REPORT_FIELDS } from "./queries";

export const CUSTOMER_USER_REPORT_PRINT_QUERY = gql`
  query CustomerUserReportPrintQuery($subsectorSlug: String!) {
    report(slug: $subsectorSlug) {
      ...ReportFields
    }
    userReport(subsectorSlug: $subsectorSlug) {
      ...UserReportFields
      ...UserReportPrintExtensionFields
    }
    user {
      ...PrintUserProfileFields
    }
  }
  ${REPORT_FIELDS}
  ${USER_REPORT_FIELDS}
  ${USER_REPORT_PRINT_EXTENSION_FIELDS}
  ${PRINT_USER_PROFILE_FIELDS}
`;

export const CUSTOMER_USER_RESULT_PRINT_DETAILS_QUERY = gql`
  query CustomerUserResultPrintDetailsQuery($userResultId: ID!) {
    userResult(userResultId: $userResultId) {
      ...UserResultPrintCoreFields
      untestedDnaDatapoints {
        id
        name
      }
      untestedDatapoints {
        id
        name
        description
        function
        reason
        advertisedTestProductName
      }
    }
  }
  ${USER_RESULT_PRINT_CORE_FIELDS}
`;
